import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { title, snakeCase } from 'change-case'

import CustomFields from "./customfields"
import Override from "./override"

class CustomFieldsSettings extends Component {
  state = {
    activeTab:
      typeof this.props.match.params.toptab !== "undefined"
        ? title(this.props.match.params.toptab)
        : "Custom Fields"
  };

  componentDidMount() {
    this.handleTabFromProp();
    window.addEventListener("popstate", this.handleTabFromProp);
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.handleTabFromProp);
  }

  handleTabFromProp = () => {
    this.setState({
      ...this.state,
      activeTab:
        typeof this.props.match.params.toptab !== "undefined"
          ? title(this.props.match.params.toptab)
          : "Custom Fields"
    });
  };

  tabChangeHandler = activeTab => {
    this.setState({ activeTab });
    this.props.history.push(
      `/system_settings/custom_fields/${snakeCase(activeTab)}`
    );
  };

  render() {
    const tabStyling = tab => this.state.activeTab === tab ? "active-tab" : "inactive-tab"
    const tabNames = [
      "Custom Fields",
      "Override"
    ];

    const tabs = tabNames.map((tab, index) => (
      <li
        key={index}
        onClick={() => this.tabChangeHandler(tab)}
        className={`nav-item font-weight-bold px-4 ${tabStyling(tab)}`}
      >
        {tab}
      </li>
    ));

    let activeTab;
    switch (this.state.activeTab) {
      case "Custom Fields":
        activeTab = <CustomFields />;
        break;
      case "Override":
        activeTab = <Override />;
        break;
      default:
        activeTab = null;
    }

    return (
      <div className="card">
        <ul className="nav nav-tabs font-weight-bold ml-0">
          {tabs}
        </ul>
        {activeTab}
      </div>
    );
  }
}

export default withRouter(CustomFieldsSettings)
